import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS, MCP_ENDPOINTS } from "../apiEndpoints";
import { MCP_REQUEST_TIMEOUT_MS } from "../../utils/HelperFunction/mcpHelpers";

const aiUrl = (path) => `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${path}`;

const asUser = (userId, extraHeaders = {}) => ({
  timeout: MCP_REQUEST_TIMEOUT_MS,
  headers: { [MCP_ENDPOINTS.USER_ID_HEADER]: userId, ...extraHeaders },
});

export const listMcpApiKeysApi = (userId) =>
  apiClient.get(aiUrl(MCP_ENDPOINTS.API_KEYS), undefined, asUser(userId));

export const listMcpToolsApi = (userId, view = "full") =>
  apiClient.get(aiUrl(MCP_ENDPOINTS.TOOLS), { view }, asUser(userId));

export const createMcpApiKeyApi = (userId, { name, tools, expiresInDays }) =>
  apiClient.post(
    aiUrl(MCP_ENDPOINTS.API_KEYS),
    { name, tools, expires_in_days: expiresInDays },
    asUser(userId, { "Content-Type": "application/json" }),
  );

export const getMcpApiKeyApi = (userId, keyId) =>
  apiClient.get(
    aiUrl(MCP_ENDPOINTS.API_KEY_BY_ID(keyId)),
    undefined,
    asUser(userId),
  );

export const deleteMcpApiKeyApi = (userId, keyId) =>
  apiClient.delete(
    aiUrl(MCP_ENDPOINTS.API_KEY_BY_ID(keyId)),
    undefined,
    asUser(userId),
  );

export const listMcpTracesApi = (userId, keyId, limit = 50) =>
  apiClient.get(
    aiUrl(MCP_ENDPOINTS.TRACES),
    { key_id: keyId, limit },
    asUser(userId),
  );
